import { inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import type { Observable } from "rxjs";

export function translocoInitializer(): Observable<any> {
  const transloco = inject(TranslocoService);
  return transloco.load(transloco.getActiveLang());
}
